import { useCallback } from "react";

import { DEFAULT_SNACKBAR_ERROR_MESSAGE } from "../../constants/strings";
import { useShowSnackbar } from "../useShowSnackbar";

export const useCopyToClipboard = () => {
  const { showSuccess, showError } = useShowSnackbar();

  const copyToClipboard = useCallback(
    async (
      text: string,
      successMessage = "Successfully copied to clipboard.",
    ) => {
      try {
        await navigator.clipboard.writeText(text);
        showSuccess(successMessage);
      } catch {
        showError(DEFAULT_SNACKBAR_ERROR_MESSAGE);
      }
    },
    [showSuccess, showError],
  );

  return { copyToClipboard };
};
